export default __webpack_public_path__ + "static/media/cook1.d57ee92b.png";